/**
 * Return a string with - appended to it at the end up to `length` characters
 * @param value {string} current partial value
 * @param length {number} total length of characters in the return value
 */
export default function appendDashToPhonePart(value, length) {
  if (value.length < length) {
    return value + '-'.repeat(length - value.length);
  }
  return value;
}
